/* GCR · Galleria foto: righe giustificate, caricamento a gruppi, visore, protezione */
if (!customElements.get('gcr-gallery')) {
  customElements.define('gcr-gallery', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-gal-grid]');
      this.lb = this.querySelector('[data-gal-lb]');
      this.big = this.querySelector('[data-gal-big]');
      this.batch = Number(this.dataset.batch) || 24;
      this.items = [...this.grid.querySelectorAll('.gcr-gal__item')].map((b) => ({
        full: b.dataset.full, alt: b.querySelector('img')?.alt || '', el: b
      }));
      try { this.rest = JSON.parse(this.querySelector('[data-gal-rest]')?.textContent || '[]'); } catch (e) { this.rest = []; }
      this.total = this.items.length + this.rest.length;
      const count = this.closest('.gcr-gal')?.querySelector('[data-gal-count]');
      if (count && this.total > 1) count.textContent = `${this.total} fotografie`;

      // comparsa morbida
      this.reveal = new IntersectionObserver((ens) => {
        for (const en of ens) if (en.isIntersecting) { en.target.classList.add('is-in'); this.reveal.unobserve(en.target); }
      }, { rootMargin: '0px 0px -6% 0px' });
      this.items.forEach((it, n) => this.watch(it.el, n));

      // gruppi successivi quando ci si avvicina alla fine
      const sentinel = this.querySelector('[data-gal-sentinel]');
      if (this.rest.length && sentinel) {
        this.more = new IntersectionObserver((ens) => { if (ens[0].isIntersecting) this.append(); }, { rootMargin: '1400px 0px' });
        this.more.observe(sentinel);
      }

      this.addEventListener('click', (e) => {
        const b = e.target.closest('.gcr-gal__item');
        if (b && this.grid.contains(b)) this.open(Number(b.dataset.galI));
      });
      this.querySelector('[data-gal-close]').addEventListener('click', () => this.lb.close());
      this.querySelector('[data-gal-prev]').addEventListener('click', () => this.show(this.i - 1));
      this.querySelector('[data-gal-next]').addEventListener('click', () => this.show(this.i + 1));
      this.lb.addEventListener('click', (e) => { if (e.target === this.lb || e.target.matches('[data-gal-stage]')) this.lb.close(); });
      this.lb.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.show(this.i + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.show(this.i - 1); }
      });
      this.lb.addEventListener('close', () => { document.documentElement.classList.remove('gcr-gal-open'); this.items[this.i]?.el?.focus({ preventScroll: true }); });

      // swipe nel visore
      let x0 = null, y0 = 0;
      const stage = this.querySelector('[data-gal-stage]');
      stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; }, { passive: true });
      stage.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.show(this.i + (dx < 0 ? 1 : -1));
        else if (dy > 90) this.lb.close();
      }, { passive: true });

      if (this.dataset.protect === 'true') {
        const stop = (e) => { if (e.target.closest('.gcr-gal__item, .gcr-gal__stage')) e.preventDefault(); };
        this.addEventListener('contextmenu', stop);
        this.addEventListener('dragstart', stop);
        this.classList.add('is-protected');
      }
    }
    disconnectedCallback() { this.reveal?.disconnect(); this.more?.disconnect(); }
    watch(el, n) { el.style.setProperty('--d', `${(n % 6) * 45}ms`); this.reveal.observe(el); }
    url(u, w) { try { const x = new URL(u, location.href); x.searchParams.set('width', w); return x.href; } catch (e) { return u; } }
    append() {
      if (!this.rest.length) { this.more?.disconnect(); return; }
      const frag = document.createDocumentFragment();
      const next = this.rest.splice(0, this.batch);
      for (const d of next) {
        const n = this.items.length;
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'gcr-gal__item'; b.dataset.galI = String(n);
        b.style.setProperty('--r', (d.w / d.h).toFixed(4));
        b.setAttribute('aria-label', `Apri foto ${n + 1}: ${d.a || ''}`);
        const img = new Image();
        img.alt = d.a || ''; img.loading = 'lazy'; img.decoding = 'async'; img.draggable = false;
        img.width = d.w; img.height = d.h;
        img.sizes = '(min-width: 990px) 33vw, 60vw';
        img.srcset = [240, 360, 480, 640, 960].map((w) => `${this.url(d.u, w)} ${w}w`).join(', ');
        img.src = this.url(d.u, 640);
        const i = document.createElement('i'); i.setAttribute('aria-hidden', 'true');
        const s = document.createElement('span'); s.className = 'gcr-gal__shield'; s.setAttribute('aria-hidden', 'true');
        b.append(i, img, s);
        frag.append(b);
        this.items.push({ full: this.url(d.u, 2200), alt: d.a || '', el: b });
        this.watch(b, n);
      }
      this.grid.append(frag);
      if (!this.rest.length) this.more?.disconnect();
    }
    open(i) {
      document.documentElement.classList.add('gcr-gal-open');
      this.lb.showModal();
      this.show(i, true);
    }
    show(i, first = false) {
      const n = this.total;
      if (!n) return;
      i = (i % n + n) % n;
      // la foto richiesta potrebbe non essere ancora nella griglia: carica i gruppi che servono
      while (i >= this.items.length && this.rest.length) this.append();
      const it = this.items[i];
      if (!it) return;
      this.i = i;
      this.big.classList.remove('is-in');
      const swap = () => {
        this.big.src = it.full; this.big.alt = it.alt;
        this.querySelector('[data-gal-cap]').textContent = it.alt;
        this.querySelector('[data-gal-pos]').textContent = `${i + 1} / ${n}`;
        const done = () => requestAnimationFrame(() => this.big.classList.add('is-in'));
        this.big.complete ? done() : this.big.addEventListener('load', done, { once: true });
      };
      first ? swap() : setTimeout(swap, 140);
      // precarica le vicine
      [i + 1, i - 1].forEach((k) => { const v = this.items[(k + n) % n]; if (v) { const p = new Image(); p.src = v.full; } });
    }
  });
}
